// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartConfigPlaceQuantityCrossArmLink } from './part-config-place-quantity-cross-arm-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigPlaceQuantity extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
  value?: string;
  partConfigPlaceQuantityCrossArmLinks!: PartConfigPlaceQuantityCrossArmLink[];
}

